import { useListingTableControllerBase } from "./useListingTableControllerBase";

/**
 * For modal/wizard steps:
 * - no cookies
 * - no scroll restore/persist
 * - uses the same controller return API
 */
export function useListingTableControllerModal(opts) {
  return useListingTableControllerBase({
    ...opts,
    // keep modal defaults here if you want:
    defaultPageSize: opts?.defaultPageSize ?? 10,
  });
}
